// ======================================================================
// File Name       : ServiceListDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { Button, Col, Modal, Table, FormControl, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues, change } from 'redux-form';
import * as enterpriseActions from '../../../actions/EnterpriseAction';
import * as ServiceConstant from '../../../constants/ServiceConstant';
import { getItemBoxName } from '../../../utils/index';
import RenderField from '../../../utils/ReduxFormUtils';
import PaginationCustom from '../../Pagination';
import TableHead from '../../TableHead';
import CustomButton from '../../button/CustomButton';
import MessageSearch from '../../../components/MessageSearch';
import service from '../../../reducers/service';

class ServiceListDialog extends Component {
  constructor(props) {
    super(props);
    this.okForm = this.okForm.bind(this);
  }

  componentWillMount() {
    const { enterprises } = this.props;
    if (!enterprises) {
      this.props.dispatch(enterpriseActions.init());
    }
  }

  okForm() {
    const { selectedService } = this.props.serviceRecordSearch.values;
    const { serviceInfo } = this.props;
    const service = $.grep(serviceInfo.serviceList, e => e.serviceCd === selectedService);
    this.props.onSelectedService(service[0]);
  }

  render() {
    {/* #7116 START */}
    const { show, serviceInfo, openDialog, getStartEndData, startPosition, isAllowShowSearchMessageInServiceDialog, onSearchServiceBtnClick} = this.props;
    {/* #7116 END */}
    const thead = [
      { title: '', sortBy: null, width: 50 },
      { title: 'サービスコード', sortBy: null },
      { title: 'サービス名', sortBy: null },
      { title: 'サービス種別', sortBy: null },
    ];
    const objectStyle = { 'background-color': 'gray' };
    let listService = [];
    let recordNum = 0;
    if (serviceInfo && serviceInfo.serviceList && serviceInfo.serviceList.length) {
      recordNum = serviceInfo.recordNum ? serviceInfo.recordNum : 0;
      listService = serviceInfo.serviceList.map((service, index) => (
        <tr
          key={index}
          className={service.dormantState === 1 && "dormant-object"}
        >
          <td className="text-center">
            <RenderField
              type="radio"
              name="selectedService"
              value={service.serviceCd}
              inline={false}
              id={service.serviceCd}
            />
          </td>
          <td style={{ padding: "0px" }}>
            <label
              className="form-label"
              htmlFor={service.serviceCd}
              className="cursor_pointer displayBlock"
              style={{ padding: "8px" }}
            >
              {service.serviceCd}
            </label>
          </td>
          <td style={{ padding: "0px" }}>
            <label
              className="form-label"
              htmlFor={service.serviceCd}
              className="cursor_pointer displayBlock"
              style={{ padding: "8px" }}
            >
              {service.serviceName}
            </label>
          </td>
          <td style={{ padding: "0px" }}>
            <label
              className="form-label"
              htmlFor={service.serviceCd}
              className="cursor_pointer displayBlock"
              style={{ padding: "8px" }}
            >
              {getItemBoxName(ServiceConstant.ServiceType, service.serviceType)}
            </label>
          </td>
        </tr>
      ));
    }
    return (
      <Modal show={show} animation={false} size={'lg'}>
        <Modal.Header onHide={this.props.cancelSelectedService} closeButton>
          <Modal.Title className="text-center">{'サービスを選択してください'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="padding-left-20 padding-right-20">
          {/* #7116 START */}
            <MessageSearch
              recordNum={recordNum}
              isAllowShowSearchMessage={isAllowShowSearchMessageInServiceDialog}
              resultList={serviceInfo.serviceList}
              dismissMessage={this.props.dismissMessage}
            />
            <Form onSubmit={(e) => { e.preventDefault(); onSearchServiceBtnClick(); }}  className='form-horizontal'>
              <Form.Group 
                className="form-info padding-left-35"
              >
                <Col as={Form.Label} sm={3} className="">
                    サービスコード
                </Col>
                <Col sm={6} >
                  <RenderField
                    type="textbox"
                    className="form-control"
                    name="dialogServiceCd"
                  />
                </Col>
              </Form.Group>
              <Form.Group 
                className="form-info padding-left-35"
              >
                <Col as={Form.Label} sm={3} className="">
                    サービス名
                </Col>
                <Col sm={6} >
                  <RenderField
                    type="textbox"
                    className="form-control"
                    name="dialogServiceName"
                  />
                </Col>
              </Form.Group>
              <Form.Group className="text-center">
                <Col sm={12} className="padding-left-right-clear">
                  <CustomButton
                    btnStyle="btn btn-primary btn-96 margin-top-20"
                    text="検索"
                    type="submit"
                    iconClass="bi bi-search"
                  />
                </Col>
              </Form.Group>
            </Form>
              <Col sm={12} className="text-right">
                <PaginationCustom
                  className="float-end"
                  recordNum={recordNum}
                  startPosition={startPosition}
                  handlePageSelect={getStartEndData.bind(this)}
                />
              </Col>
              <Table striped hover>
                <thead>
                  <TableHead data={thead} />
                </thead>
                <tbody>{listService}</tbody>
              </Table>
          {/* #7116 END */}
          </div>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button key={0} className="btn-96" variant="default" onClick={this.props.cancelSelectedService}>
            {'キャンセル'}
          </Button>
          <Button key={1} className="btn-96 btn-primary" onClick={this.okForm}>
            {'OK'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceInfo } = state.serviceRecord;
  const { serviceRecordSearch } = state.form;
  const { enterprises } = state.enterprise;
  return {
    ...{ serviceInfo },
    ...{ serviceRecordSearch },
    ...{ enterprises },
  };
};

export default connect(mapStateToProps)(ServiceListDialog);
